import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/landing/SiteHeader";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Approach } from "@/components/landing/Approach";
import { Services } from "@/components/landing/Services";
import { About } from "@/components/landing/About";
import { Faq, faqs } from "@/components/landing/Faq";
import { Vista } from "@/components/landing/Vista";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { useReveal } from "@/hooks/use-reveal";
import { absoluteUrl, OG_IMAGE, SITE_NAME, SITE_URL } from "@/lib/site";

const TITLE = "Jerry's Therapy — Licensed Counseling in Minnesota | Jerome Bottelberghe, LPC";
const DESC =
  "Compassionate, confidential counseling with Jerome Bottelberghe, LPC. Telehealth and in-person therapy for individuals, couples, and families in Minnesota — including LGBTQ+, family-related transitions, and abuse recovery.";

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": ["LocalBusiness", "MedicalBusiness", "ProfessionalService"],
      "@id": `${SITE_URL}/#practice`,
      name: SITE_NAME,
      description: DESC,
      url: SITE_URL,
      image: OG_IMAGE,
      telephone: "+1-507-530-2029",
      email: "jrbrmb123@yahoo.com",
      address: {
        "@type": "PostalAddress",
        streetAddress: "110 East Second Street",
        addressRegion: "MN",
        addressCountry: "US",
      },
      founder: {
        "@type": "Person",
        name: "Jerome Bottelberghe",
        jobTitle: "Licensed Professional Counselor",
        alumniOf: "Walden University",
      },
      areaServed: {
        "@type": "State",
        name: "Minnesota",
      },
      knowsLanguage: ["English"],
      sameAs: ["https://www.facebook.com/JerrysTherapy/"],
    },
    {
      "@type": "FAQPage",
      "@id": `${SITE_URL}/#faq`,
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: f.a,
        },
      })),
    },
  ],
};

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { name: "theme-color", content: "#7c8a6a" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: absoluteUrl("/") },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESC },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/` }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(jsonLd),
      },
    ],
  }),
  component: Index,
});

function Index() {
  useReveal();
  return (
    <div className="relative min-h-screen">
      <a
        href="#contact"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground"
      >
        Skip to contact
      </a>
      <SiteHeader />
      <main>
        <Hero />
        <Marquee />
        <Approach />
        <Services />
        <About />
        <Faq />
        <Vista />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
